import { ArrowIcon } from "../components/Icons";
import { PageHero } from "../components/PageHero";
import { BOOKING_URL, PHONE_DISPLAY, PHONE_HREF, serviceGroups } from "../site";

export function ServicesPage() {
  return (
    <>
      <PageHero
        eyebrow="Cuts, color & care"
        title="Services built around your hair."
        description="Let our professional, attentive team help you find the cut, color, treatment, and finish that makes you feel your best. Free consultations are available."
        image="/images/salon-hero.jpg"
      />
      <section className="section service-menu-section">
        <div className="container">
          <div className="service-menu-intro">
            <p>Prices shown are starting points and may vary by hair length, density, stylist, technique, and product needs. For the most accurate quote, please <a href={PHONE_HREF}>call {PHONE_DISPLAY}</a> to book a free consultation.</p>
            <a className="button" href={BOOKING_URL} target="_blank" rel="noreferrer">Book online <ArrowIcon /></a>
          </div>
          <div className="service-groups">
            {serviceGroups.map((group, groupIndex) => (
              <article className="service-group" key={group.title}>
                <div className="service-group__heading">
                  <span>{String(groupIndex + 1).padStart(2, "0")}</span>
                  <div><h2>{group.title}</h2>{group.note && <p>{group.note}</p>}</div>
                </div>
                <dl>
                  {group.items.map((item) => (
                    <div key={item.name}><dt>{item.name}</dt><span aria-hidden="true" /><dd>{item.price}</dd></div>
                  ))}
                </dl>
              </article>
            ))}
          </div>
        </div>
      </section>
      <section className="simple-cta">
        <div className="container simple-cta__inner">
          <div><p className="eyebrow eyebrow--light">Not sure what to book?</p><h2>Start with a free consultation.</h2></div>
          <a className="button button--light" href={PHONE_HREF}>Call {PHONE_DISPLAY} <ArrowIcon /></a>
        </div>
      </section>
    </>
  );
}
